export const formatPhoneNumber = (value: string, notDisplay?: boolean): string => {
    if (!value) return value;
    if (notDisplay) {
        const phoneNumber = value.split('|');
        return `${phoneNumber[0]}${phoneNumber[1]}`;
    } else {
        const prevValue = value;
        value = value.split('|')[1];
        if (!value) {
            value = prevValue;
        }
        const phoneNumber = value
            .replace(/^\+(1)/, '')
            .replace(/^\+(84)/, '0')
            .replace(/\D/g, '');

        if (phoneNumber.length < 10 || phoneNumber.length > 20) {
            return value;
        }

        const areaCode = phoneNumber.slice(0, 3);
        const firstPart = phoneNumber.slice(3, 6);
        const secondPart = phoneNumber.slice(6);

        return `(${areaCode}) ${firstPart}-${secondPart}`;
    }
}